<template>


  <ModalContainer queryParam="f012" ref="modalContainer" size="xl">
    <b-overlay id="overlay-background" :show="showOverlay" 
      rounded="sm">

      <ModalViewFile v-if="fileToView" :urlFile="fileToView" v-model="isModalFileVisible" />
       <div class="mb-1 row p-1" v-if="dataProceso">
          <div class="col"><b>Procedimiento:</b> {{ dataProceso.procedimiento }}</div>
          <div class="col"><b>Paciente: </b> {{ dataProceso.paciente }}</div>
        </div>
      
      <div class="mb-1 text-center">
        <h5 class="text-primary">INFORME COLPOSCOPIA -</h5>

      </div>

      <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-"
        active-tab-class="font-weight-bold text-dark">
        <b-tab title="Imagen" active>
          <b-row>

            <div class="col-6">
              <label>Subir imágenes:</label>
              <b-row class="my-1">
                <b-col>
                  <b-form-file
                    v-model="imagesToUpload"
                    accept=".pdf"
                    @change="onFileChange"
                    placeholder="Selecciona un archivo PDF"
                    browse-text="Examinar"
                  ></b-form-file>
                </b-col>
                <b-col size="md">
                  <b-button v-if="dataJsonColposcopia.imagenes" variant="outline-success" @click="onViewFile">Ver
                    Anterior</b-button>
                </b-col>
              </b-row>
              <label>Buscar diagnósticos:</label>
              <b-row>
                <b-col cols="10">
                  <SearchOpts v-model="searchDiagnostico" :searchService="diagnosticosService.getByQuerySelect"
                    :minChars="3" :placeholder="'Buscar diagnostico...'" class="form-control-sm" />
                </b-col>
                <b-col cols="2" class="text-right">
                  <b-button variant="primary" size="sm" @click="agregarDiagnostico">
                    Agregar
                  </b-button>
                </b-col>
                <b-col class="my-4">
                  <b-table class="my-4"
                    v-if="dataJsonColposcopia.tableDiagnosticos && dataJsonColposcopia.tableDiagnosticos.length"
                    :items="dataJsonColposcopia.tableDiagnosticos" :fields="fieldsDiagnosticos" small>
                    <template #cell(acciones)="data">

                      <b-button class="text-center" variant="danger" size="sm" @click="removeDiagnostico(data.index)">
                        <font-awesome-icon icon="circle-xmark" style="color: white" />
                      </b-button>

                    </template>

                  </b-table>
                </b-col>
              </b-row>


            </div>


            <b-col cols="6">

              <span class="text-left"> Seleccione: </span>


              <b-row>

                
           

                <!-- <table class=" col-10 table table-bordered tablea-1 col-md-8 mx-auto">
                  <thead>
                    <tr>
                      <th></th>
                      <th v-for="num in numbers">{{ num }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="letter in letters" :key="letter">
                      <td>{{ letter }}</td>
                      <td v-for="num in numbers" :key="num">
                        <b-form-checkbox multiple class="check-colposcopia b-form-check-input custom-checkbox" v-model="selected"
                          type="checkbox" :id="letter + num" :value="letter + num" />
                      </td>
                    </tr>
                  </tbody>
                </table> -->

                 <table class="col-10 table table-bordered tablea-1 col-md-8 mx-auto">
                <thead>
                  <tr>
                    <th></th>
                    <th v-for="num in numbers" :key="'head-' + num">{{ num }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="letter in letters" :key="letter">
                    <td >{{ letter }}</td>
                    <td  v-for="num in numbers" :key="letter + '-' + num" >
                    
                      <b-form-checkbox
                        
                        v-model="selected"
                        :value="letter + num"
                        
                      ></b-form-checkbox>
                      
                    </td>
                  </tr>
                </tbody>
              </table>
            
                


                <b-col cols="2" class="text-left">
                  <b-button variant="warning" @click="limpiarSeleccion" title="Reiniciar seleccion">
                    <i class="fa-solid fa-repeat" />
                  </b-button>
                </b-col>

                <b-col cols="12">
                  <div class="table-responsive">
                    <table ref="tabla" class="table fondo table-borderless custom-table col-md-8 mx-auto">
                      <tbody>
                        <tr v-for="(row, rowIndex) in 26" :key="rowIndex">
                          <td v-for="(column, columnIndex) in 26" :key="columnIndex" :class="{ 'p-0': true }" :style="{
                            backgroundColor: getCellColor(rowIndex, columnIndex),
                            borderRadius: getBorderRadius(rowIndex, columnIndex),
                          }">
                            {{ rowIndex * 6 + columnIndex + 1 }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </b-col>
              </b-row>

            </b-col>
          </b-row>
        </b-tab>

        <b-tab title="Informe">
          <b-row class="p-2">

            <b-col cols="8" class="my-1">
              <label>Quien realizo el procedimiento?:</label>
              <div v-if="doctortext">
                <b-input-group>
                  <b-form-input disabled v-model="doctortext"></b-form-input>

                  <template #append>
                    <b-button variant="danger" title="Cambiar medico" @click="doctortext = null">
                      <i class="fa-solid fa-trash" />
                    </b-button>
                  </template>
                </b-input-group>


              </div>

              <SearchOpts v-else v-model="dataJsonColposcopia.doctor"
                :searchService="doctoresService.searchDoctoresByTermSelect" :placeholder="'Buscar doctor...'"
                class="form-control-sm" />
            </b-col>

          
            <b-col class="mt-1" cols="12">
              <label>Hallazgos:</label>
              <b-form-textarea v-model="dataJsonColposcopia.hallazgos" />
            </b-col>

            <b-col class="mt-1" cols="12">
              <label>Conclusiones y Sugerencias:</label>
              <b-form-textarea v-model="dataJsonColposcopia.concsug" />
            </b-col>
          </b-row>


        </b-tab>

      </b-tabs>
      <div class="text-right mt-2">
        <b-button size="lg" variant="primary" @click="guardarInformeColposcopia()">
          <i class="fa-solid fa-floppy-disk"></i> Guardar
        </b-button>
      </div>

    </b-overlay>
  </ModalContainer>

</template>

<script>

import Ripple from "vue-ripple-directive";
import html2canvas from "html2canvas";

import { doctoresService, auxiliarService, fileService } from "@/shared/services";
import { SearchOpts, ModalContainer } from "@/shared/components";
import { mapState } from "vuex";
import { diagnosticosService } from "../../../atencionMedica/services";
import { procedimientosFormulariosService } from "../../services";
import ModalViewFile from "../../../../shared/components/ModalViewFile/ModalViewFile.vue";

export default {
  directives: {
    Ripple,
  },


  components: {
    SearchOpts,
    ModalContainer,
    ModalViewFile
  },

  props:{
    dataProceso:{
      default:null,
      required:false
    }
  },

  data() {
    return {
      showOverlay: false,
      idRegistroForm: null,
      tokenProceso: null,
      tokenFormulario: null,
      doctortext: "",
      auxiliartext: "",
      imagesToUpload: null,
      dataJsonColposcopia: {
        doctor: null,
        auxiliar: null,
        descripcion: null,
        informe: null,
        conclusion: null,
        concsug: null,
        hallazgos: null,
        diagnosticos: null,
        tableDiagnosticos: [],
        tableImagenes: [],
        grafico: {
          blob: null,
          checksSelected: null
        },
        msps: null,
        imagenes: null
      },

      fieldsDiagnosticos: [
        {
          key: "diagnostico",
          label: "Diagnostico",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "acciones",
          label: "acciones",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-right",
        },
      ],
      searchDoctor: null,
      searchAuxiliar: null,
      searchDiagnostico: null,
      doctoresService,
      auxiliarService,
      diagnosticosService,

      indexImgAct: null,
      imagenBase64: "",
      selectedCheckboxes: [],
      letters: ["A", "B", "C", "D", "E", "F", "G", "H"],
      numbers: [1, 2, 3, 4, 5, 6],
  
      selected: [],
      imagencolcos: "",
      webcamEncendida: false,
      fecharealizacion: "",
      seRealizo: false,

      informe: "",
      conclusion: "",
      doctor: null,
      auxiliar: null,
      fechaEjecucion: "",
      realizado: null,
      hallazgos: null,
      conclusugeren: null,
      descripcionproc: null,

      tableData: [
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
      ],

      diagnosticosearch: "",
      esPrincipal: false,
      doctores: [], // Agrega tus opciones para doctores
      auxiliares: [], // Agrega tus opciones para auxiliares
      opsDiagnosticos: [], // Agrega tus opciones para diagnósticos
      isLoading: false,
      diagnosticos: [], // Aquí almacenarás los diagnósticos agregados
      fieldsti: ["diagnostico", "acciones"], // Define los campos para la tabla

      capturedImgs: [], //Capturar solo las url de las imagenes
      capturedImageUrl: "", // URL de la imagen capturada actualmente
      files: [], // Aquí almacenarás los archivos seleccionados
      fileuploaded: "",
      isDragging: false, // Variable para detectar si se está arrastrando un archivo

      diags: [],
      fileToView: null,
      isModalFileVisible: false

    };
  },

  computed: {
    ...mapState({
      stdocsMsps: state => state.docsMsps.files
    }),

    cellCases() {
      return [
        { label: "A1", row: 11, column: 13, index: 80 },
        { label: "A2", row: 8, column: 13, index: 62 },
        { label: "A3", row: 9, column: 15, index: 64 },
        { label: "A4", row: 5, column: 13, index: 44 },
        { label: "A5", row: 5, column: 16, index: 47 },
        { label: "A6", row: 7, column: 17, index: 60 },
        // Campo A //
        { label: "B1", row: 12, column: 15, index: 88 },
        { label: "B2", row: 10, column: 17, index: 78 },
        { label: "B3", row: 12, column: 17, index: 90 },
        { label: "B4", row: 8, column: 19, index: 68 },
        { label: "B5", row: 10, column: 20, index: 81 },
        { label: "B6", row: 12, column: 20, index: 93 },
        // Campo B //
        { label: "C1", row: 14, column: 14, index: 100 },
        { label: "C2", row: 14, column: 17, index: 102 },
        { label: "C3", row: 16, column: 17, index: 114 },
        { label: "C4", row: 14, column: 20, index: 105 },
        { label: "C5", row: 16, column: 20, index: 117 },
        { label: "C6", row: 18, column: 19, index: 128 },
        // Campo C //
        { label: "D1", row: 16, column: 13, index: 87 },
        { label: "D2", row: 18, column: 13, index: 78 },
        { label: "D3", row: 17, column: 15, index: 90 },
        { label: "D4", row: 22, column: 13, index: 68 },
        { label: "D5", row: 21, column: 15, index: 81 },
        { label: "D6", row: 20, column: 17, index: 93 },
        // Campo D //
        { label: "E1", row: 16, column: 11, index: 102 },
        { label: "E2", row: 18, column: 9, index: 112 },
        { label: "E3", row: 19, column: 11, index: 120 },
        { label: "E4", row: 20, column: 7, index: 140 },
        { label: "E5", row: 21, column: 9, index: 136 },
        { label: "E6", row: 22, column: 11, index: 132 },
        // Campo E //
        { label: "F1", row: 14, column: 10, index: 87 },
        { label: "F2", row: 14, column: 7, index: 78 },
        { label: "F3", row: 16, column: 8, index: 90 },
        { label: "F4", row: 14, column: 4, index: 68 },
        { label: "F5", row: 16, column: 4, index: 81 },
        { label: "F6", row: 18, column: 5, index: 93 },
        // Campo F //
        { label: "G1", row: 12, column: 10, index: 80 },
        { label: "G2", row: 12, column: 7, index: 62 },
        { label: "G3", row: 10, column: 8, index: 64 },
        { label: "G4", row: 12, column: 4, index: 44 },
        { label: "G5", row: 10, column: 5, index: 47 },
        { label: "G6", row: 8, column: 5, index: 60 },
        // Campo G //
        { label: "H1", row: 11, column: 11, index: 87 },
        { label: "H2", row: 9, column: 9, index: 78 },
        { label: "H3", row: 8, column: 11, index: 90 },
        { label: "H4", row: 7, column: 7, index: 68 },
        { label: "H5", row: 5, column: 9, index: 81 },
        { label: "H6", row: 4, column: 11, index: 93 },
        // Campo H //
      ];
    },
  },

  created() {
    if (this.jsonInforColpos) {
      this.dataJsonColposcopia = this.jsonInforColpos
      this.selected = this.jsonInforColpos.grafico.checksSelected
      this.doctortext = this.jsonInforColpos?.doctor?.text
      this.auxiliartext = this.jsonInforColpos?.auxiliar?.text
    }

  },



  methods: {

    onFileChange(event) {
    const file = event.target.files[0];

    if (file && file.type !== "application/pdf") {
      this.imagesToUpload = null;

      this.$swal.fire({
        icon: "error",
        title: "Archivo inválido",
        text: "Solo se permiten archivos PDF.",
      });
    }
  },


    onViewFile() {
      this.fileToView = this.dataJsonColposcopia.imagenes;
      this.isModalFileVisible = true;
    },


    limpiarSeleccion() {
      this.selected = [];
      this.tableData = [
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
        ["", "", "", "", "", ""],
      ];
    },

    async capturarTabla() {
      const tabla = this.$refs.tabla;
      try {
        const canvas = await html2canvas(tabla);
        this.imagenBase64 = canvas.toDataURL("imagen/png");

        const corteimagenBase64 = this.imagenBase64.replace(
          "data:image/png;base64,",
          ""
        ); // Reemplaza el prefijo por una cadena vacía

        return corteimagenBase64

      } catch (error) {
        console.error("Error al capturar la tabla:", error);
        return null;
      }
    },


    getCellColor(rowIndex, columnIndex) {
      const cellIndex = rowIndex * 6 + columnIndex + 1;
      const cell = this.cellCases.find(
        (cell) => cell.row === rowIndex
          && cell.column === columnIndex
          && this.selected.includes(cell.label)
      );
      return cell ? "red" : "";
    },


    getBorderRadius(rowIndex, columnIndex) {
      const cell = this.cellCases.find(
        (cell) => cell.row === rowIndex
          && cell.column === columnIndex
          && this.selected.includes(cell.label)
      );
      return cell ? "80%" : "";
    },


    agregarDiagnostico() {
      if (!this.searchDiagnostico || !this.searchDiagnostico.text) {
        this.$swal({
          title: "Campos Incompletos",
          text: "Por favor, seleccione un diagnóstico antes de agregar.",
          icon: "warning",
          confirmButtonText: "Ok",
        });
        return;
      }

      let diagnosticosYaExistentes = false

      const nuevoDiagId = {
        diag: this.searchDiagnostico?.value,
      };

      const nuevoDiagnostico = {
        diagnostico: this.searchDiagnostico?.text,
      };

      const dataTable = this.dataJsonColposcopia.tableDiagnosticos;
      
      if (dataTable && dataTable.length > 5) {
        this.$swal.fire({
          icon: "info",
          text: "No puede agregar mas de 6 diagnosticos",
        });
        return;
      }


      this.dataJsonColposcopia.tableDiagnosticos.push(nuevoDiagnostico);
      this.diags.push(nuevoDiagId);

      this.searchDiagnostico = null
    },



    deleteImage(index) {
      this.dataJsonColposcopia.tableImagenes.splice(index, 1);
    },

    removeDiagnostico(index) {
      this.dataJsonColposcopia.tableDiagnosticos.splice(index, 1);
    },


    async guardarInformeColposcopia() {

       const dataTable = this.dataJsonColposcopia.tableDiagnosticos;
      console.log("data table", dataTable)
      if (!dataTable || dataTable.length < 1) {
        this.$swal.fire({
          icon: "info",
          text: "Debe agregar un diagnostico al menos"})
        return;
      }
      if (this.imagesToUpload) {
        this.dataJsonColposcopia.imagenes = await fileService.upload('imagenes', this.imagesToUpload, 'img');
      }

      const dataJson = JSON.stringify(this.dataJsonColposcopia);

      const params = {
        nameForm: "12b",
        dataJson: dataJson,
        tokenProceso: this.tokenProceso,
        idRegistroForm: this.idRegistroForm,
        tokenFormulario: this.tokenFormulario
      }

      const responseSave = await procedimientosFormulariosService.guardarData(params);

      if (!responseSave) {
        this.$swal({
          title: "Error",
          text: "Ocurrio un error al guardar",
          icon: "error",
          confirmButtonColor: "#089599",
        });
        return;
      }

      await this.$swal.fire({
        icon: "success",
        text: "Guardado correctamente",
      });
       this.$emit("formulario-guardado");

     
    }

  },


  watch: {
    '$route': {
      deep: true,
      immediate: true,
      async handler(newValue) {
        this.showOverlay = true
        if (newValue && newValue.query)
        console.log("new value", newValue)
        this.tokenProceso = newValue.query?.forms || null
        this.tokenFormulario = newValue.query?.f012 || null
        if (this.tokenFormulario && this.tokenFormulario !== 'x') {

          console.log("entra aqui token formulario", this.tokenFormulario)
          const data = await procedimientosFormulariosService.obtenerFormProcDataByToken(this.tokenFormulario);
          let data_json = JSON.parse(data.dataJson)
          if (data_json) {
            this.dataJsonColposcopia = data_json
            this.selected = data_json?.grafico?.checksSelected
            console.log("data json", this.dataJsonColposcopia)

          }
        } else {

          this.selected = []
          this.dataJsonColposcopia = {
            doctor: null,
            auxiliar: null,
            descripcion: null,
            informe: null,
            conclusion: null,
            concsug: null,
            hallazgos: null,
            diagnosticos: null,
            tableDiagnosticos: [],
            tableImagenes: [],
            grafico: {
              blob: null,
              checksSelected: null
            },
            msps: null,
            imagenes: null
          }
        }
        this.showOverlay = false



      }
    },

    jsonInforColpos: {
      deep: true,
      immediate: true,
      handler(newValue) {
        if (newValue)
          this.dataJsonColposcopia = newValue
      }
    },

    selected: {
      deep: true,
      immediate:true,
      async handler(newValue) {
        this.dataJsonColposcopia.grafico.checksSelected = newValue
        await this.$nextTick();
        this.dataJsonColposcopia.grafico.blob = await this.capturarTabla()
      }
    },

    stdocsMsps: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.dataJsonColposcopia.msps = newVal
      }
    },

    dataJsonColposcopia: {
      deep: true,
      immediate: true,
      handler(newVal) {
        console.log("data json colposcopia", newVal)
        localStorage.setItem("jsonInformeColpos", JSON.stringify(newVal))
      }
    },

    


  }
};
</script>

<!-- Estilos opcionales -->

<style scoped>
@import "./stylesColposcopia.css";
</style>
